



















import {Component, Prop, Vue} from "vue-property-decorator";
import {Pricing, SeatConfigurationDto} from "../../api";
import {SeatSelection} from "./models/SeatSelection";

@Component({
  components: {}
})
export default class ReservationItem extends Vue {
  @Prop() public selectedItem!: SeatSelection | null;
  @Prop() public index!: number;

  private onSelectionChanged() {
    this.$emit('priceconfig-changed', {SeatSelection: this.selectedItem, SelectedPricing: this.selectedPrice})
  }
  
  private onRemoveSelection() {
    this.$emit('seatFreedEvent', {seatCode: this.selectedItem?.seatCode})
  }

  public selectedPrice: Pricing | null = null;
}
